import { useHistory } from 'react-router-dom';

export default function LoginPage() {
  const history = useHistory();

  history.replace('/');

  return null;
}
